// 5 row × 6 col bay diagram used on the picker hero for low locations.
// Each bay has 6 slots per shelf and 5 shelves; A1 is bottom-left, E6
// is top-right. The picker is shown the whole grid with the slot they
// need lit in brand orange so they can find it at a glance without
// decoding the bay_position string ("A1") cognitively.
//
// Rendered only when the consumer passes a non-null bayPosition AND the
// caller has decided the location is low — PickingScreen gates on both.
import "./PickingScreen.css";

// Top → bottom rendering, so E (top shelf) sits at the top of the grid
// visually. Pickers think about the top shelf as the top of the diagram.
const ROW_LABELS = ["E", "D", "C", "B", "A"] as const;
const COLS = 6;

type Props = {
    /** "A1".."E6" — slot to highlight. */
    bayPosition: string;
};

const BayDiagram = ({ bayPosition }: Props) => {
    const row = bayPosition.charAt(0);
    const col = parseInt(bayPosition.slice(1), 10);
    if (!ROW_LABELS.includes(row as typeof ROW_LABELS[number])) return null;
    if (!Number.isFinite(col) || col < 1 || col > COLS) return null;

    return (
        <div className="ps-bay">
            <div className="ps-bay-grid">
                {ROW_LABELS.map(rl =>
                    Array.from({ length: COLS }, (_, c) => {
                        const isActive = (c + 1) === col && rl === row;
                        return (
                            <span
                                key={`${rl}${c}`}
                                className={"ps-bay-cell" + (isActive ? " ps-bay-cell--active" : "")}
                                aria-label={isActive ? `Slot ${rl}${c + 1} (current pick)` : undefined}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default BayDiagram;
